/* eslint-disable react/prop-types */
import React from 'react'
import { useSelector } from 'react-redux'
import { useOutletContext } from 'react-router-dom'
import RoutedMenu from '../../../../RoutedMenu/RoutedMenu'
import { hasPolicy } from '../../../../../redux/selectors'
import { DEVELOPER_ACCESS } from '../../../../../auth/policies'

export function GovXIDTab() {
  const {
    verificationListing,
    canUpdate,
    canUpdateBillingRules,
    subTab,
  } = useOutletContext()
  const hasDeveloperAccess = useSelector(hasPolicy(DEVELOPER_ACCESS))

  if (!verificationListing || !verificationListing.id) {
    return null
  }
  return (
    <div style={{ margin: '30px 0 0 0' }}>
      <RoutedMenu
        activeTab={subTab}
        items={[
          {
            label: 'Affiliations',
            to: 'affiliations',
          },
          {
            label: 'Listing Display',
            to: 'listing-display',
          },
          {
            label: 'Listing Messaging',
            to: 'listing-messaging',
          },
          {
            label: 'Campaigns',
            to: 'campaigns',
          },
          {
            label: 'Data Sharing',
            to: 'data-sharing',
          },
          {
            label: 'Email Settings',
            to: 'email-settings',
          },
          {
            label: 'Offer Page',
            to: 'offer-page',
          },
          {
            label: 'OAuth Links',
            to: 'oauth-links',
          },
          {
            label: 'Whitelisted URLs',
            to: 'whitelisted-urls',
          },
          {
            label: 'Credentials',
            to: 'credentials',
          },
          {
            label: 'GOVX Login',
            to: 'govx-login',
          },
          ...(hasDeveloperAccess ? [{ label: 'OpenID Connect', to: 'openid-connect' }] : []),
        ]}
        context={{
          verificationListing,
          canUpdate,
          canUpdateBillingRules,
        }}
      />
    </div>
  )
}

export default GovXIDTab
